import React, { useState } from 'react'
import {Link,useHistory} from 'react-router-dom'
import firebase from 'firebase'
import { Button,Input } from '@material-ui/core'
import { Label } from '@material-ui/icons'
import './Chat.css'
import { NavBar } from '../navBar'
import axios from '../../axios'


export const AddRoom =() => {
    const history = useHistory()
    const [room, setRoom] = useState({ roomname: '' })
    const ref = firebase.database().ref('rooms/')

    const createRoom = (evt) => {
        const Data = { setRoom: room}
        axios.post('/roomlist.json', Data).then((res) => {
            console.log(res);
        })
        evt.preventDefault()
        ref.orderByChild('roomname').equalTo(room.roomname).once('value', snapshot => {
            if (snapshot.exists()) {
                return (
                alert('room already exists!')  
                )
            } else {
                const newRoom = firebase.database().ref('rooms/').push()
                newRoom.set(room)
                history.goBack()
            }
        })
    }

    const handleonChange = (evt) => {
        evt.persist()
        setRoom({...room, [evt.target.name]: evt.target.value})
    }

    return (
        <div className= 'chat__add__room__container'>
            <NavBar />
                <h2 id = 'add__room__title'>Create a new room</h2>
                <p id = 'add__room__text'>Please feel free to create a new chat room that has not already been created.</p>
                <div className = 'add__room'>
                        <Label>Room Name</Label>
                        <Input type='text' name='roomname' id='roomname' placeholder='Enter Room Name' value={room.roomname} onChange={handleonChange} />
                    <Button variant='primary' type='submit' onClick = {createRoom}>
                        Add
                    </Button>
                    <br />
                    <button id = 'go__back' variant='primary'>
                        <Link to = '/roomlist'>Go Back</Link>
                    </button>
        </div>
        </div>
    )

}
